import React from 'react';

const RenewalPage: React.FC = () => {
  return (
    <div>
      <h1>Subscription Inactive</h1>
      <p>Your subscription is not active. Please renew to continue accessing the platform.</p>
      <button onClick={() => window.location.href = 'https://your-payment-page.com'}>Renew Now</button>  // Replace with actual payment URL
    </div>
  );
};

export default RenewalPage;